<template>
<div class="flex flex-col main">
  <div class="head">
    <div class="head-i flex flex-between flex-align-center">
      <div class="flex flex-align-center">
        <img class="logo margin-rt-10" src="../../assets/images/login/logo2.png" alt="">
        <el-menu    background-color="#fff"
                    text-color="#fff"
                    class="menu-my"
                    active-text-color="#F9FF00"
                    :default-active="activeIndex"  mode="horizontal" @select="handleSelect">
<!--          <el-menu-item index="1">通知公告</el-menu-item>-->
          <el-menu-item index="/activity">活动中心</el-menu-item>
          <el-submenu index="3" class="menu-my-sele">
            <template slot="title">会员管理</template>
            <el-menu-item  index="/teammanagement" class="hei">团队单位</el-menu-item>
            <el-menu-item  index="/referee" class="hei">裁判员库</el-menu-item>
            <el-menu-item  index="/person" class="hei">个人会员</el-menu-item>
          </el-submenu>
          <el-submenu index="4" class="menu-my-sele">
            <template slot="title">运维管理</template>
            <el-menu-item  index="/orgmanagement" class="hei">组织管理</el-menu-item>
            <el-menu-item  index="/usemanagement" class="hei">用户管理</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>

      <div class="flex flex-align-center" v-if="user" >
        <el-image
            v-if="user.headIcon"
            class="usericon" :src="user.headIcon"
            fit="cover"></el-image>
        <img v-else class="usericon" src="../../assets/images/login/usericon.png" alt="">
        <div class="font-16"  style="margin: 0 20px 0 10px">{{user.name}}</div>
        <div  class="font-16" @click="exit" style="cursor: pointer">退出</div>
      </div>
    </div>
  </div>
<!--  :key="new Date().getTime()-->
  <div class="global-padd-15 flex1 ">
    <router-view />
  </div>
  <div class="text-center">
    © {{new Date().getFullYear()}} 杭州市田径协会 <a href="https://beian.miit.gov.cn" target="_blank" >浙ICP备2025143842号</a>
  </div>
<!--  <div class="flex1 page">-->
<!--    <router-view/>-->
<!--  </div>-->
</div>
</template>

<script>
// import {mapActions} from "vuex";

export default {
  name: "index",
  data(){
    return {
      user:undefined,
      activeIndex:'1',
    }
  },
  created() {
    // this.getUserInfo()
  },
  mounted() {
    this.getUserInfo()
    if(sessionStorage.getItem('activeIndex')){
      this.activeIndex=sessionStorage.getItem('activeIndex')
    }
  },
  methods:{
    // ...mapActions(['setUser']),
    handleSelect(key, keyPath) {
      // console.log(key, keyPath,this.activeIndex);
      sessionStorage.setItem('activeIndex',key)
      // this.activeIndex=key
      // let url ;
      // switch (key) {
      //   case "DOCUMENT_CHECK":
      //      url= '/manage/documentreview'
      //     break
      //   case "AI_KNOWLEDGE_MANAGE":
      //     url = '/AILibrary/list'
      //     break
        // default:
        //       return  '白lv0'
        //       break

      // }
      // if(!url){
      //   this.$router.push('/')
      // }
      this.$router.push(key)
    },
    exit(){
      this.$confirm('正在退出账号, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('_$_zzb-access-token')
        this.$router.push('/login')
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消退出账号'
        });
      });
    },
    getUserInfo(){
      this.$http.get('/rest/my/info',null,data=>{
        this.user=data
        sessionStorage.setItem('user',JSON.stringify(data))
        // this.setUser(data)
        // console.log(this.$route.fullPath)
        // if(this.$route.fullPath!="/index"){
        //   this.$router.replace("/index")
        // }
      })
    }
  }
}
</script>

<style scoped>
.main{
  width: 100%;
  height: 100%;
}
.el-menu.el-menu--horizontal{
  border-bottom: none;
}
.hei{
  color: #333!important;
}
.menu-my>.el-menu-item,/deep/ .menu-my-sele>.el-submenu__title{
  background: #4680FE!important;
  font-size: 16px;
}
/deep/ .el-submenu__title i{
  color:#fff!important;
}
/deep/ .is-active .el-submenu__title i{
  color:#F9FF00!important;
}
.usericon{
  height: 40px;
  width: 40px;
  border-radius: 40px;
}
/*.page{*/
/*  background-size: 480px auto;*/
/*  background-image: url("../../assets/images/login/wx_web_home_logo03.png");*/
/*  background-repeat: no-repeat;*/
/*  background-position: center center;*/
/*  padding: 15px;*/
/*}*/
.logo{
  height: auto;
  width: 200px;
}
.head{
  height: 70px;
  width: 100%;
  background: #4680FE ;
  color: #fff;
}
.head-i{
  width: 80%;
  height: 70px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/view/index/index.vue